import React from 'react';
import { Link } from 'react-router-dom';

export default function RefundPolicy() {
  return (
    <div className="min-h-screen bg-white text-black font-sans">

      {/* === HEADER SECTION === */}
      <div className="bg-gray-50 pt-28 pb-10 md:pt-32 md:pb-16 border-b border-gray-300">
        <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row justify-between items-start md:items-center">
          <h1 className="text-3xl md:text-4xl font-black text-black mb-4 md:mb-0">
            Cancellation & Refund Policy
          </h1>

          {/* Breadcrumb */}
          <nav className="text-sm font-medium">
            <Link to="/" className="text-orange-600 hover:text-orange-700">
              Home
            </Link>
            <span className="mx-2 text-gray-500">/</span>
            <span className="text-gray-700">Cancellation & Refund Policy</span>
          </nav>
        </div>
      </div>

      {/* === CONTENT SECTION === */}
      <div className="max-w-7xl mx-auto px-4 py-12 md:py-16">
        <div className="space-y-12 max-w-5xl">

          {/* 1. RETURNS */}
          <section>
            <h2 className="text-xl font-black text-black uppercase mb-4">1. Returns</h2>
            <div className="space-y-4 text-base leading-relaxed text-black">
              <p>
                Our return policy lasts <strong>1 day (24 hours)</strong> for the items marked as refundable on the product detail page from the date of purchase. After 1 day from activation, unfortunately, we can’t offer you a refund.
              </p>
              <p>
                Returns are applicable only for items that were listed inappropriately, such as missing data, missing information, or missing video content that was displayed on the detail page.
              </p>
              <p className="font-bold text-black">
                No cancellation shall be allowed once the item has been purchased.
              </p>
              <p>
                Each item/service listed by us will be available for a specific duration of time depending on your period of purchase. Once the subscription period is over, the item will no longer be accessible, and no refund/return will be applicable.
              </p>
            </div>
          </section>

          {/* 2. REFUNDS */}
          <section>
            <h2 className="text-xl font-black text-black uppercase mb-4">2. Refunds</h2>
            <div className="space-y-4 text-base leading-relaxed text-black">
              <p>
                Once your return request is received and inspected, we will send you an email notifying you about the approval or rejection of the refund request.
              </p>
              <p>
                If approved, your refund will be processed, and the credit will automatically be applied to your credit/debit card or original method of payment within a certain number of days.
              </p>
            </div>
          </section>

          {/* 3. LATE OR MISSING REFUNDS */}
          <section>
            <h2 className="text-xl font-black text-black uppercase mb-4">3. Late or Missing Refunds</h2>
            <div className="space-y-4 text-base leading-relaxed text-black">
              <p>If you haven’t received your refund yet:</p>
              <ul className="list-disc pl-5 space-y-2">
                <li>First, check your bank account again.</li>
                <li>Refunds may take <strong>7–10 business days</strong> to process and reflect in your bank account.</li>
              </ul>
              <p>If you’ve done all of this and still haven’t received your refund, please contact us at:</p>
              <p className="font-bold text-blue-700">
                📩 info@vidyazon.com
              </p>
            </div>
          </section>

          {/* 4. EXCHANGES */}
          <section>
            <h2 className="text-xl font-black text-black uppercase mb-4">4. Exchanges</h2>
            <div className="space-y-4 text-base leading-relaxed text-black">
              <p>We only offer refunds of the amount.</p>
              <p>
                If you want to exchange it with another item, please send us an email at{" "}
                <a href="mailto:info@vidyazon.com" className="text-blue-700 font-medium hover:underline">
                  info@vidyazon.com
                </a>{" "}
                or send a refund request using the link available in your customer account section.
              </p>
            </div>
          </section>

          {/* 5. DELETE ACCOUNT */}
          <section>
            <h2 className="text-xl font-black text-black uppercase mb-4">5. De-activate / Delete Account</h2>
            <div className="space-y-4 text-base leading-relaxed text-black">
              <p>
                Any Vidyazon mobile app (iOS or Android) or web user can delete their Vidyazon user account at any time.
              </p>
              <p>To delete an account from the app:</p>
              <ul className="list-disc pl-5 space-y-2">
                <li>Go to <strong>My Dashboard</strong> from the left menu.</li>
                <li>At the bottom of the page, a <strong>Deactivate Account</strong> link is available.</li>
                <li>Click the link, accept the <strong>Delete Account Terms</strong>, and press <strong>Delete My Account</strong>.</li>
              </ul>
              <p>
                Once clicked, the user account will be deactivated immediately and the user will be logged out automatically. After <strong>90 days</strong>, the user data will be removed permanently.
              </p>

              <div className="bg-blue-50 p-5 rounded-lg border-l-4 border-blue-600 mt-4">
                <p className="font-bold text-black mb-1">Account Recovery</p>
                <p className="text-sm text-black">
                  Vidyazon provides users the right to recover an accidentally deleted account. It can be retrieved within <strong>15 days</strong> of deletion by sending an email to{" "}
                  <a href="mailto:info@vidyazon.com" className="text-blue-700 font-medium hover:underline">
                    info@vidyazon.com
                  </a>, subject to successful verification by our technical team.
                </p>
              </div>
            </div>
          </section>

        </div>
      </div>

    </div>
  );
}
